<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form">
      <h3 class="editor-header">{{ modelUpdate.id > 0 ? $t('pricing_model_conversion.edit_mode') :  $t('pricing_model_conversion.add_mode')}}</h3>
      <div class="col-sm-12 form-data nopads">
        <span class="span-title">{{ $t('pricing_model_conversion.unit') }}</span>
        <multiselect
            v-model="unit"
            :options="unitOptions"
            :multiple="false"
            :close-on-select="true"
            label="text"
            track-by="value"
            :searchable="true"
            :selected-label="$t('common.selected')"
            :select-label="$t('common.select')"
            :deselect-label="$t('common.remove_selection')"
            :placeholder="$t('pricing_model_conversion.select_unit')"
            :disabled="loading"
          >
            <template
              #singleLabel="props"
            >
              <span class="option__desc">
                <span class="option__title">{{ props.option.text }}</span>
              </span>
            </template>
            <template
              #option="props"
            >
              <div class="option__desc">
                <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
              </div>
            </template>
            <template #noResult>
              <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
              <span>{{ $t('common.no_results') }}</span>
            </template>
          </multiselect>

        <span class="span-title">{{ $t('pricing_model_conversion.code') }}</span>
        <multiselect
          v-model="code"
          :options="forestCodeOptions"
          :multiple="false"
          :close-on-select="true"
          label="text"
          track-by="value"
          :searchable="true"
          :selected-label="$t('common.selected')"
          :select-label="$t('common.select')"
          :deselect-label="$t('common.remove_selection')"
          :placeholder="$t('pricing_model_conversion.select_code')"
          :disabled="loading"
        >
          <template
            #singleLabel="props"
          >
            <span class="option__desc">
              <span class="option__title">{{ props.option.text }}</span>
            </span>
          </template>
          <template
            #option="props"
          >
            <div class="option__desc">
              <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
            </div>
          </template>
          <template #noResult>
            <span>{{ $t('common.not_found') }}</span>
          </template>
          <template #noOptions>
            <span>{{ $t('common.no_results') }}</span>
          </template>
        </multiselect>
        <span class="span-title">{{ $t('pricing_model_conversion.pricing_model') }}</span>
        <multiselect
          v-model="pricingModel"
          :options="pricingModelOptions"
          :multiple="false"
          :close-on-select="true"
          label="text"
          track-by="value"
          :searchable="true"
          maxHeight="170"
          :selected-label="$t('common.selected')"
          :select-label="$t('common.select')"
          :deselect-label="$t('common.remove_selection')"
          :placeholder="$t('pricing_model_conversion.select_pricing_model')"
          :disabled="loading || priceList"
        >
          <template
            #singleLabel="props"
          >
            <span class="option__desc">
              <span class="option__title">{{ props.option.text }}</span>
            </span>
          </template>
          <template
            #option="props"
          >
            <div class="option__desc">
              <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
            </div>
          </template>
          <template #noResult>
            <span>{{ $t('common.not_found') }}</span>
          </template>
          <template #noOptions>
            <span>{{ $t('common.no_results') }}</span>
          </template>
        </multiselect>

          <div class="form-check mb-3 mt-2">
              <input
                  id="price_list"
                  class="form-check-input"
                  type="checkbox"
                  v-model="priceList"
              >
              <label class="form-check-label" for="price_list">
                  {{ $t('pricing_model_conversion.price_list') }}
              </label>
          </div>

        <div class="col-sm-12 text-end my-2" style="padding-top: 5em">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="!canSubmit" @click.stop="submit">
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <base-modal
      v-if="deletion"
      @ok="deleteConversionModel()"
      @close="deletion = false"
    >
      <div class="modal-body">
        <span>{{ $t('common.confirm_delete') }}</span>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {priceHelper} from "@/components/mixins/PricingMixin";
import {conversionModelHelper, units} from '@/components/mixins/ConversionMixin'
import {restApi} from '@/components/mixins/RestApiMixin'
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: 'ConversionModelEditor',
    components: {BaseModal},
    mixins: [conversionModelHelper, restApi, units, priceHelper],
    props: {
        model: {
            type: Object,
            default: null
        },
        conversionModels: {
            type: Array,
            default() {
                return []
            }
        },
        codes: {
            type: Array,
            default() {
                return []
            }
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            unit: null,
            code: null,
            priceList: null,
            deletion: false,
            pricingModel: null,
            pricingModels: [],
            pricingModelOptions: [],
            modelUpdate: this.jsonToItem(this.model),
            unitOptions: [
                {text: this.$t('pricing_model_conversion.select_unit'), value: null},
                {text: units.KILOGRAMS, value: 1},
                {text: units.TONS, value: 2},
                {text: units.METERS, value: 3},
                {text: units.SQUARE_METERS, value: 4},
                {text: units.CUBIC_METERS, value: 5},
                {text: units.KILOMETERS, value: 6},
                {text: units.PCS, value: 7},
                {text: units.HOURS, value: 8},
            ]
        }
    },

    computed: {
        canSubmit() {
            if (this.loading || !this.unit) {
                return false;
            }
            if ((!this.pricingModel || !this.pricingModel.value) && !this.priceList) {
                return false;
            }
            return true
        },
        forestCodeOptions() {
            const nullVal = { value: null, text: this.$t('pricing_model_conversion.select_code') }
            if ((!this.codes || !Object.keys(this.codes).length) || this.loading) {
                return [nullVal]
            }
            // Sort by code
            this.codes.sort((a, b) => a.code - b.code);
            return [
                nullVal,
                ...this.codes.map(item => ({
                    value: item.code,
                    id: item.id,
                    text: item.code + ' - ' + item.name
                }))
            ]
        },
    },
    mounted: function () {
        this.fetchPricingModels()
        if (this.modelUpdate.id > 0) {
            this.unit = this.modelUpdate.unit ? this.unitOptions.find(item => item.text === this.modelUpdate.unit) : null
            this.priceList = !!this.modelUpdate.price_list
            if (this.modelUpdate.code && this.modelUpdate.code.id) {
                let foundCode = this.codes.find(item => item.id === this.modelUpdate.code.id)
                if (foundCode) {
                    this.code = {text: foundCode.name + ' ' + '(' + foundCode.code + ')', value: foundCode.code, id: foundCode.id}
                }
            }
        }
    },

    methods: {
        fetchPricingModels: function () {
            this.loading = true
            this.restFetch(this.pricingModeUrl, this.handlePricingModelsSuccess)
        },

        handlePricingModelsSuccess: function (response) {
            this.pricingModels = response.data
            this.handlePricingModels()
            this.loading = false
        },

        handlePricingModels() {
            this.pricingModelOptions = []
            // set empty option value
            this.pricingModelOptions.push({text: this.$t('pricing_model_conversion.select_pricing_model'), value: null})
            this.pricingModels && this.pricingModels.forEach(pricingModel => {
                if(this.modelUpdate.pricing_model && this.modelUpdate.pricing_model.id && pricingModel.id === this.modelUpdate.pricing_model.id) {
                    // set preselected pricing model
                    this.pricingModel = {text: this.pricingModelToText(pricingModel), value: pricingModel.id}
                }
                this.pricingModelOptions.push({text: this.pricingModelToText(pricingModel), value: pricingModel.id})
            })
        },

        setDefaultValues: function (model) {
            if (!this.unit || !this.unit.value) {
                this.showAlert(this.$t('pricing_model_conversion.invalid_unit'))
                return undefined
            }
            if ((!this.pricingModel || !this.pricingModel.value) && !this.priceList) {
                this.showAlert(this.$t('pricing_model_conversion.invalid_pricing_model'))
                return undefined
            }
            if(this.unit) {
                model.unit = this.unit.text
            }
            if(this.code && this.code.id) {
                model.code = this.codes.find(item => item.id === this.code.id)
            } else {
                model.code = null
            }
            if(this.priceList) {
                model.price_list = this.priceList
            } else {
                model.price_list = false
            }
            if(this.pricingModel && !this.priceList) {
                model.pricing_model = this.pricingModels.find(item => item.id === this.pricingModel.value)
            }
            if(this.checkForDuplicates(model)) {
                this.showAlert(this.$t('pricing_model_conversion.duplicate_conversion'))
                return undefined
            }
            return model
        },

        submit: function () {
            let json = this.setDefaultValues(this.modelUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.modelUpdate.id < 1) {
                    this.restAdd(this.pricingModeConversionUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.pricingModeConversionUrl, json, this.success, this.fail)
                }
            }
        },

        checkForDuplicates(updateModel) {
            let duplicates = false
            if(this.conversionModels !== null) {
                this.conversionModels.every(cModel => {
                    let codeDefined = cModel.hasOwnProperty('code')
                    if(cModel.unit === updateModel.unit &&
                        // check if forestcode is defined and same as update forestcode
                        (codeDefined && updateModel.code && cModel.code.code === updateModel.code.code ||
                        // or check if forestcode is not defined and trying to update with null
                        !codeDefined && !updateModel.code) &&
                        // we also want to check if we are updating existing conversion model
                        cModel.id !== updateModel.id)
                    {
                        duplicates = true
                        return false;
                    }
                    return true
                })

            }
            return duplicates
        },

        deleteConversionModel: function () {
            this.deletion = false
            this.loading = true
            var url = this.pricingModeConversionUrl + '/' + this.modelUpdate.id
            this.restDelete(url, this.success, this.fail)
        },

        confirmDeleteConversionModel() {
            if (!this.loading) {
                this.deletion = true
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
